import React, { useContext, useEffect } from 'react';

import { type UseDisclosureProps } from '@chakra-ui/react';

export type AdminLayoutContextNavDisplayed = boolean;

export type AdminLayoutContextValue = {
  navDisplayed: AdminLayoutContextNavDisplayed;
  setNavDisplayed: React.Dispatch<
    React.SetStateAction<AdminLayoutContextNavDisplayed>
  >;
  navDrawer: UseDisclosureProps;
};

export const AdminLayoutContext =
  React.createContext<AdminLayoutContextValue | null>(null);

export const useAdminLayoutContext = () => {
  const ctx = useContext(AdminLayoutContext);
  if (ctx === null) {
    throw new Error('Missing parent <AdminLayout> component');
  }
  return ctx;
};

export const useAdminLayoutHideNav = (
  displayed: AdminLayoutContextNavDisplayed = true
) => {
  const { setNavDisplayed } = useAdminLayoutContext();

  useEffect(() => {
    setNavDisplayed(displayed);
    return () => setNavDisplayed(true);
  }, [setNavDisplayed, displayed]);
};
